const oFeedSectionEmpty = {
  oFeedSectionEmpty: {
    message: {
      products: 'Puedes crear un nuevo producto, incluir formaciones, definir formas y medios de pago, generar cartas de venta y mucho más!',
      projects: 'Puedes crear una nueva formación, incluir contenidos, definir días de activación, generar notificaciones y mucho más!'
    },

    title: {
      products: 'Aún no tienes productos creados',
      projects: 'Aún no tienes formaciones creadas'
    }
  }
}

export default oFeedSectionEmpty
